// assets/funny-story-generator.js

document.addEventListener('DOMContentLoaded', () => {

    // --- Variable Declarations ---
    // Get references to the main HTML elements from the snippet
    const storyGeneratorApp = document.getElementById('story-generator-app');
    const adlibFormDiv = document.getElementById('adlib-form');
    const generateBtn = document.getElementById('generate-btn');

    const resultsContainer = document.getElementById('results-container'); // NEW: Main container for results
    const generatedImageArea = document.getElementById('generated-image-area'); // Container for image and title
    const generatedStoryTitleElement = document.getElementById('generated-story-title'); // Element for generated title
    const generatedStoryImage = document.getElementById('generated-story-image'); // The img element itself
    const downloadImageBtn = document.getElementById('download-image-btn'); // NEW: Image download button

    const storyOutputDiv = document.getElementById('story-output'); // Container for text story output
    const storyTextElement = document.getElementById('story-text'); // Paragraph element for the generated story text
    const shareButtonsDiv = document.querySelector('.share-buttons'); // Container for share/copy buttons below text output

    const loadingOverlay = document.getElementById('generator-loading-overlay'); // Enhanced loading overlay element

    // Variables for the Share Modal
    const shareModalOverlay = document.getElementById('share-modal-overlay');
    const shareModalContent = shareModalOverlay ? shareModalOverlay.querySelector('.share-modal-content') : null;
    const closeModalSpan = shareModalContent ? shareModalContent.querySelector('.close-modal') : null;
    const modalShareButtonsDiv = shareModalContent ? shareModalContent.querySelector('.modal-share-buttons') : null;
    const storySummaryElement = shareModalContent ? document.getElementById('story-summary-to-share') : null;

    // Variables for Generator Link Share (NEW)
    const generatorShareUrlInput = shareModalOverlay ? document.getElementById('generator-share-url') : null;
    const copyGeneratorUrlBtn = shareModalOverlay ? document.getElementById('copy-generator-url-btn') : null;


    // Variables for Story Type Selection
    const storyTypeButtonsContainer = document.getElementById('story-type-buttons');
     const storyTypeErrorElement = document.getElementById('story-type-error');


    // --- Story Type and Input Definitions ---
    // Define the available story types - These strings MUST exactly match the 'type' property in your backend STORY_TEMPLATES
    const storyTypes = [
        'funny thriller',
        'sentimental mystery',
        'action packed comedy',
        'hilariously ironic',
        'Adventurous Touching',
        'Nostaligic Whimsical',
        'Chaotic Hilarious',
        'Calm and Weird'
    ];

    // Define the 4 descriptive inputs needed for the story generation (removed 'how_felt')
    const descriptiveInputs = [
        { id: 'story_about', label: "What's the story about?" },
        { id: 'details', label: "What details do you remember?" },
        { id: 'who_was_there', label: "Who was there?" },
        { id: 'story_ending', label: "How did the story end?" }
    ];

    let selectedStoryType = null;


    // --- Function Definitions ---

    function createStoryTypeButtons() {
        if (!storyTypeButtonsContainer) { console.error("#story-type-buttons container not found."); return; }
        storyTypes.forEach(type => {
            const button = document.createElement('button');
            button.textContent = type;
            button.classList.add('story-type-button');
            button.setAttribute('data-story-type', type);
            button.addEventListener('click', () => {
                storyTypeButtonsContainer.querySelectorAll('.story-type-button').forEach(btn => {
                    btn.classList.remove('selected');
                });
                button.classList.add('selected');
                selectedStoryType = type;
                 console.log('Selected story type:', selectedStoryType);
                 if (storyTypeErrorElement) storyTypeErrorElement.classList.add('hidden');
            });
            storyTypeButtonsContainer.appendChild(button);
        });
    }

    function createDescriptiveForm() {
        if (!adlibFormDiv) { console.error("#adlib-form element not found."); return; }
        adlibFormDiv.innerHTML = '';
        descriptiveInputs.forEach(item => {
            const div = document.createElement('div');
            div.classList.add('input-field-wrapper');
            const label = document.createElement('label');
            label.setAttribute('for', item.id);
            label.textContent = item.label + ':';
            const input = document.createElement('input');
            input.setAttribute('type', 'text');
            input.setAttribute('id', item.id);
            input.setAttribute('name', item.id);
            input.setAttribute('required', true);
            input.classList.add('descriptive-input-field');
            div.appendChild(label);
            div.appendChild(input);
            adlibFormDiv.appendChild(div);
        });
    }

    function getUserInputs() {
        const inputs = {};
        descriptiveInputs.forEach(item => {
            const inputElement = document.getElementById(item.id);
            let value = '';
            if (inputElement) { value = inputElement.value.trim(); }
            inputs[item.id] = value;
        });
        return inputs;
    }

    async function generateStory(inputs, type) {
        console.log('Attempting to generate story for type:', type, 'with inputs:', inputs);

        // Hide previous results and show loading
        if (generateBtn) generateBtn.disabled = true;
        if (loadingOverlay) {
            loadingOverlay.classList.remove('hidden');
            setTimeout(() => { loadingOverlay.classList.add('visible'); }, 10);
        }
        if (resultsContainer) resultsContainer.classList.add('hidden'); // NEW: Hide results container
        if (storyTypeErrorElement) storyTypeErrorElement.classList.add('hidden');

        try {
            // --- **CRITICAL: Replace 'YOUR_RENDER_SERVICE_URL' with your ACTUAL Render service base URL** ---
            const renderEndpointUrl = 'https://story-generator-owkd.onrender.com/generate-story';
            const dataToSend = { story_type: type, inputs: inputs };
            console.log('Sending data to backend:', dataToSend);

            const response = await fetch(renderEndpointUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(dataToSend),
            });

            if (!response.ok) {
                 const errorBody = await response.json().catch(() => ({ error: response.statusText }));
                 console.error('Backend response not OK:', response.status, errorBody);
                 throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorBody.error || 'Unknown error from server'}`);
            }

            // Expecting response to include story, imageUrl, and title
            const data = await response.json();
             if (!data || !data.story || !data.imageUrl || !data.title) {
                 console.warn('GenerateStory received unexpected data format:', data);
                 throw new Error('Invalid response format from server. Expected story, imageUrl, and title.');
             }
            console.log('GenerateStory succeeded, received data:', data);
            return data;

        } catch (error) {
            console.error('Error in generateStory:', error);
            const errorMessageElement = storyTextElement || document.createElement('p');
            errorMessageElement.textContent = `Error: ${error.message || 'Something went wrong. Please try again.'}`;
            if (storyOutputDiv) storyOutputDiv.classList.remove('hidden');
            if (generatedImageArea) generatedImageArea.classList.add('hidden'); // Hide image area on error
            if (resultsContainer) resultsContainer.classList.remove('hidden'); // Show container for error message
            return null;
        } finally {
            if (generateBtn) generateBtn.disabled = false;
            if (loadingOverlay) {
                 loadingOverlay.classList.remove('visible');
                 setTimeout(() => { loadingOverlay.classList.add('hidden'); }, 300);
            }
        }
    }

    // --- NEW: Function to handle image download ---
    async function downloadImage(imageUrl, fileName) {
        try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName || 'generated_image.png';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url); // Clean up URL object
            console.log('Image download initiated.');
        } catch (error) {
            console.error('Error downloading image:', error);
            alert('Failed to download image. Please try again.');
        }
    }

    // --- Share Modal Functions ---
    function showShareModal(data) {
        const story = data.story;
        const imageUrl = data.imageUrl; // Use for context if needed, not directly creating here.
        const title = data.title; // NEW: Get title for modal

        if (!shareModalOverlay || !shareModalContent || !closeModalSpan || !modalShareButtonsDiv || !storySummaryElement) {
            console.error("Share modal elements not found in showShareModal."); return;
        }
        console.log('showShareModal function called. Modal elements found.');

        // Update modal title and story text
        // Update the main share title element to use the generated title if present
        if (shareModalContent.querySelector('.share-title')) {
            shareModalContent.querySelector('.share-title').textContent = title || 'Share Your Story:';
        }
        storySummaryElement.textContent = story;

        modalShareButtonsDiv.innerHTML = ''; // Clear previous buttons

        const encodedStory = encodeURIComponent(story);
        const encodedStorySnippet = encodedStory; // Full story for supported platforms
        // --- **CRITICAL: Replace with your ACTUAL Shopify Generator Page URL** ---
        const pageUrl = encodeURIComponent('https://aprilxxv.com/pages/funny-story-generator');
        const encodedImageUrl = encodeURIComponent(imageUrl);

        // Twitter Link
        const twitterShareModal = document.createElement('a');
        twitterShareModal.href = `https://twitter.com/intent/tweet?text=${encodedStorySnippet}&url=${pageUrl}`;
        twitterShareModal.target = '_blank';
        twitterShareModal.textContent = 'Share on Twitter';
        twitterShareModal.classList.add('share-button', 'twitter-share-button');
        modalShareButtonsDiv.appendChild(twitterShareModal);

        // Facebook Link
        const facebookShareModal = document.createElement('a');
        facebookShareModal.href = `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;
        facebookShareModal.target = '_blank';
        facebookShareModal.textContent = 'Share on Facebook';
        facebookShareModal.classList.add('share-button', 'facebook-share-button');
        modalShareButtonsDiv.appendChild(facebookShareModal);

        // WhatsApp Link
        //const whatsappShareModal = document.createElement('a');
        //whatsappShareModal.href = `whatsapp://send?text=${encodedStorySnippet}%20${pageUrl}`;
        //whatsappShareModal.setAttribute('data-action', 'share/whatsapp/share');
       // whatsappShareModal.target = '_blank';
        //whatsappShareModal.textContent = 'Share on WhatsApp';
        //whatsappShareModal.classList.add('share-button', 'whatsapp-share-button');
        //modalShareButtonsDiv.appendChild(whatsappShareModal);

        // --- Populate Generator Link for Easy Sharing (NEW) ---
        if (generatorShareUrlInput) {
            generatorShareUrlInput.value = decodeURIComponent(pageUrl); // Display the actual URL
        }

        shareModalOverlay.classList.remove('hidden');
        setTimeout(() => { shareModalOverlay.classList.add('visible'); }, 10);
        document.body.style.overflow = 'hidden';
    }

    function hideShareModal() {
        if (!shareModalOverlay) return;
        shareModalOverlay.classList.remove('visible');
        setTimeout(() => { shareModalOverlay.classList.add('hidden'); }, 300);
        document.body.style.overflow = '';
    }

    // Function to set up the share/copy buttons area below the output
    function setupShareButtonsArea(data) {
        const story = data.story;
        const title = data.title; // NEW: Get title from data object for context

        if (!shareButtonsDiv) { console.error(".share-buttons container not found."); return; }
        shareButtonsDiv.innerHTML = '<h3 class="share-title">Share Your Story:</h3>';

        const showModalButton = document.createElement('button');
        showModalButton.textContent = 'Share Story';
        showModalButton.classList.add('generator-button', 'share-modal-trigger');
        showModalButton.addEventListener('click', () => { showShareModal(data); });
        shareButtonsDiv.appendChild(showModalButton);

        // --- Create dedicated Copy Text button ---
        const copyTextButton = document.createElement('button');
        copyTextButton.textContent = 'Copy Text';
        copyTextButton.classList.add('generator-button', 'copy-story-button');
        copyTextButton.addEventListener('click', async () => {
            try { await navigator.clipboard.writeText(story); copyTextButton.textContent = 'Copied!'; setTimeout(() => { copyTextButton.textContent = 'Copy Text'; }, 2000); }
            catch (err) { console.error('Failed to copy text: ', err); copyTextButton.textContent = 'Failed to copy!'; }
        });
        shareButtonsDiv.appendChild(copyTextButton);
    }


    // --- Event Listeners ---

    // Generate button click listener
    if (generateBtn) {
        generateBtn.addEventListener('click', async () => {
            console.log('Generate button clicked. Starting story, image, and title generation...');

            if (!selectedStoryType) { console.warn('Validation failed: No story type selected.'); if (storyTypeErrorElement) storyTypeErrorElement.classList.remove('hidden'); return; }
            const inputs = getUserInputs();
            const allInputsFilled = descriptiveInputs.every(item => inputs[item.id] && inputs[item.id].trim() !== '');
            if (!allInputsFilled) { console.warn('Validation failed: One or more descriptive input fields are empty.'); alert('Please fill in all the story details.'); return; }

            console.log('Validation passed. Proceeding to generate.');
            const generatedData = await generateStory(inputs, selectedStoryType);

            if (generatedData) {
                console.log('Generation succeeded. Displaying results.');

                // --- Display generated title ---
                if (generatedStoryTitleElement) {
                    generatedStoryTitleElement.textContent = generatedData.title;
                } else { console.error("#generated-story-title element not found. Cannot display title."); }

                // --- Display generated image ---
                if (generatedStoryImage) {
                    generatedStoryImage.src = generatedData.imageUrl;
                    generatedStoryImage.alt = `Scene for a ${generatedData.title || selectedStoryType} story`;
                    if (generatedImageArea) generatedImageArea.classList.remove('hidden'); // Show image container
                } else { console.error("#generated-story-image or #generated-image-area not found. Cannot display image."); }

                // --- Display generated story text ---
                if (storyTextElement) storyTextElement.textContent = generatedData.story;
                if (storyOutputDiv) storyOutputDiv.classList.remove('hidden'); // Show text area

                // --- Show the entire results container ---
                if (resultsContainer) resultsContainer.classList.remove('hidden');

                // --- Setup the Share/Copy buttons area below the output ---
                setupShareButtonsArea(generatedData);

            } else {
                console.log('Story, image, and title generation failed.');
            }
        });
    } else { console.error("#generate-btn element not found. Cannot attach click listener."); }


    // --- New: Image Download Button Listener ---
    if (downloadImageBtn) {
        downloadImageBtn.addEventListener('click', () => {
            const imageUrl = generatedStoryImage.src;
            const fileName = generatedStoryImage.alt.replace(/\s+/g, '_').toLowerCase() + '.png'; // Clean alt text for filename
            if (imageUrl && imageUrl !== 'https://cdn.shopify.com/s/files/1/0075/9988/2287/files/april_logo_notxt.png?v=1746743579') { // Don't download fallback
                downloadImage(imageUrl, fileName);
            } else {
                alert("No image to download or image is fallback.");
            }
        });
    }


    // --- Generator Link Copy Button Listener (NEW) ---
    if (copyGeneratorUrlBtn) {
        copyGeneratorUrlBtn.addEventListener('click', async () => {
            const urlToCopy = generatorShareUrlInput ? generatorShareUrlInput.value : '';
            if (!urlToCopy) { console.warn("No generator URL to copy."); return; }
            try {
                await navigator.clipboard.writeText(urlToCopy);
                copyGeneratorUrlBtn.textContent = 'Copied!';
                setTimeout(() => { copyGeneratorUrlBtn.textContent = 'Copy Link'; }, 2000);
            } catch (err) {
                console.error('Failed to copy generator URL: ', err);
                copyGeneratorUrlBtn.textContent = 'Failed to copy!';
            }
        });
    }


    // --- Share Modal Closing Event Listeners ---
    if (closeModalSpan) { closeModalSpan.addEventListener('click', hideShareModal); } else { console.warn(".close-modal element not found for share modal."); }
    if (shareModalOverlay) {
         shareModalOverlay.addEventListener('click', (event) => { if (event.target === shareModalOverlay) { hideShareModal(); } });
         document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && shareModalOverlay.classList.contains('visible')) { hideShareModal(); } });
    } else { console.error("#share-modal-overlay element not found. Share modal will not function."); }


    // --- Initialization Logic ---

    // Dynamically create the story type selection buttons
    createStoryTypeButtons();

    // Dynamically create the descriptive input form fields
    createDescriptiveForm();

    // Ensure elements that should be hidden on load are hidden
    if (storyOutputDiv) storyOutputDiv.classList.add('hidden');
    if (loadingOverlay) loadingOverlay.classList.add('hidden');
    if (shareModalOverlay) shareModalOverlay.classList.add('hidden');
    if (storyTypeErrorElement) storyTypeErrorElement.classList.add('hidden');
    if (generatedImageArea) generatedImageArea.classList.add('hidden'); // Image area hidden initially
    if (resultsContainer) resultsContainer.classList.add('hidden'); // NEW: Results container hidden initially


    console.log('DOMContentLoaded finished, initial setup complete.');

}); // End DOMContentLoaded listener